<app-header>
  <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
</app-header>
<mat-toolbar class="main-toolbar cf-flex-row cf-justify-content-end" color="primary">
  <div class="left-side">
    <span class="title">{{ getProjectName(projectEntity$ | async) }}</span>
  </div>
  <button *ngIf="canAddHood$ | async" data-test="AddProductButton" mat-button (click)="addProduct()">
    {{ 'UI.Project.Action.AddProduct' | translate }}
  </button>
  <button *ngIf="canViewAndEditPrices$ | async" routerLink="./prices" mat-button>
    {{ 'UI.Project.Action.ViewPrices' | translate }}
  </button>
  <app-project-file-download></app-project-file-download>
</mat-toolbar>
<div class="main-content">
  <div *ngIf="showLoading$ | async" class="loading cf-flex-row cf-justify-content-center">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>

  <div *ngIf="(showLoading$ | async) === false" class="cf-flex-column cf-gap-24">
    <div *ngIf="projectEntity$ | async as projectEntity">
      <app-product-list [projectEntity]="projectEntity"></app-product-list>
    </div>
    <div *ngIf="projectEntity$ | async as projectEntity" class="cf-flex-row cf-justify-content-center">
      <app-project-form [projectEntity]="projectEntity"></app-project-form>
    </div>
  </div>
</div>
